import { RetailerPartnerType } from '../enum/index.js';
const config = {
    type: RetailerPartnerType.WALMART,
    baseURI: 'https://goto.walmart.com/c/2375857/1207219/9383?veh=aff&sourceid=imp_000011112222333344',
    affiliateURI: 'https://affil.walmart.com/cart/0/2?storeId=~{id}~&items='
};
export default config;
